import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const useDeleteProvider = () => {
  const authContext = useAuth();
  const { workspaceId } = useParams();

  return useMutation({
    mutationFn: (id: string) => {
      return fetch(`${ENDPOINTS.providers(workspaceId ?? "")}/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authContext?.userToken}`,
        },
      });
    },
  });
};
